const AVAILABLE_MONITOR = [
    'temperature',
    'heart_rate',
    'oxygen_saturation',
    'blood_glucose'
];
const randomNumber = (minimum, maximum) => Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
export const getDefaultsMonitor = () => AVAILABLE_MONITOR;
export const getMonitor = (monitor) => {
    switch (monitor) {
        case 'temperature':
            const temperature = randomNumber(34, 42);
            return {
                key: 'temperature',
                unit: 'C°',
                value: temperature,
                alert: temperature > 37
            };
        case 'heart_rate':
            const heart_rate = randomNumber(40, 112);
            return {
                key: 'heart_rate',
                unit: 'bpm',
                value: heart_rate,
                alert: heart_rate < 60 || heart_rate > 100
            };
        case 'oxygen_saturation':
            const oxygen_saturation = randomNumber(88, 100);
            return {
                key: 'oxygen_saturation',
                unit: '%',
                value: oxygen_saturation,
                alert: oxygen_saturation < 95
            };
        case 'blood_glucose':
            const blood_glucose = randomNumber(50, 160);
            return {
                key: 'blood_glucose',
                unit: 'mg/dL',
                value: blood_glucose,
                alert: blood_glucose < 60 || blood_glucose > 140
            };
    }
};
